import { useState, useLayoutEffect, useRef } from 'react';

import {
  DROPDOWN_POSITION_TOP,
  DROPDOWN_POSITION_BOTTOM,
  DROPDOWN_POSITION_BOTTOM_RIGHT,
  DROPDOWN_POSITION_LEFT,
  DROPDOWN_POSITION_RIGHT,
} from './DropDown.constants';

export const useDropDownPresenter = ({
  ref,
  targetRef,
  position: startPosition,
  gap,
  height,
  width,
  children,
}) => {
  const newRef = useRef();
  const dropDownRef = ref || newRef;
  const dropDownHeight = height || dropDownRef.current?.getBoundingClientRect()?.height || 0;
  const dropDownWidth = width || dropDownRef.current?.getBoundingClientRect()?.width || 0;
  const [position, setPosition] = useState(startPosition);
  const [coordinates, setCoordinates] = useState({ x: 0, y: 0, width: 'auto' });

  const presenter = {
    dropDownRef,
    position,
    setPosition,
    coordinates,
    setCoordinates,

    calculateCoordinates() {
      if (!targetRef?.current || !dropDownRef?.current) {
        return;
      }

      const target = targetRef.current.getBoundingClientRect();
      switch (position) {
        case DROPDOWN_POSITION_LEFT: {
          setCoordinates({
            x: target.x - dropDownWidth - gap,
            y: window.scrollY + target.y,
            width: 'auto',
          });
          return;
        }
        case DROPDOWN_POSITION_RIGHT: {
          setCoordinates({
            x: target.x + target.width + gap,
            y: window.scrollY + target.y,
            width: 'auto',
          });
          return;
        }
        case DROPDOWN_POSITION_TOP: {
          setCoordinates({
            x: target.x,
            y: window.scrollY + target.y - dropDownHeight - gap,
            width: target.width,
          });
          return;
        }
        case DROPDOWN_POSITION_BOTTOM: {
          setCoordinates({
            x: target.x,
            y: window.scrollY + target.y + target.height + gap,
            width: target.width,
          });
          return;
        }
        case DROPDOWN_POSITION_BOTTOM_RIGHT:
          setCoordinates({
            x: target.x + target.width - dropDownWidth,
            y: window.scrollY + target.y + target.height + gap,
            width: target.width,
          });
          return;
        default: {
          // do nothing
        }
      }
    },
  };

  useLayoutEffect(() => {
    presenter.calculateCoordinates();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [position, children, gap, height, width, dropDownHeight, dropDownWidth]);

  return presenter;
};
